import { _BusinessComment, BusinessCreateType, Business, ICreateBusinessComment, BusinessUpdateInterface, BusinessCommentUpdate, BusinessTable } from '@/entities/business';
import { Api } from './api/axios-config';
import { BusinessSourceService } from './BusinessSourceService';
import { useToast } from '@/components/shadcn/ui/use-toast';

export class BusinessService {

  private static api = Api();

  public static async revertCanceledBusiness(businessId: number) {
    const response = await this.api.patch(`/revertC/${businessId}`);
    if (response.status !== 200) {
      return null
    }
    return response.data;
  }

  public static async revertAprovedBusiness(businessId: number) {
    const response = await this.api.patch(`/revertA/${businessId}`);
    if (response.status !== 200) {
      return null
    }
    return response.data;
  }

  public static async revertDeclineBusiness(businessId: number) {
    const response = await this.api.patch(`/revertD/${businessId}`);
    if (response.status !== 200) {
      return null
    }
    return response.data
  }

  public static async declineBusiness(businessId: number, business: BusinessUpdateInterface) {
    const response = await this.api.patch(`decline/${businessId}`, {
      reason: business.reason
    })
    if (response.status !== 200) {
      return null
    }
    return response.data;
  }

  public static async getAllDecline() {
    const response = await this.api.get(`getDeclined`)
    if (response.status !== 200) {
      return null
    }
    return response.data;
  }

  public static async getBusinessById(BusinesId: number) {

    const response = await this.api.get<any>(`/business/${BusinesId}`);
    if (response.status !== 200) {
      return null;
    }
    // console.log(response.data);
    return response.data;
  }

  public static async getAllCanceled() {

    const response = await this.api.get<any>(`/getCancel`);
    if (response.status !== 200) {
      return null;
    }
    // console.log(response.data);
    return response.data;
  }

  public static async prepareBusiness(businessId: number) {

    const response = await this.api.patch<any>(`/prepare/${businessId}`);
    if (response.status !== 200) {
      return null;
    }
    // console.log(response.data);
    return response.data;
  }

  public static async getAllAproved() {

    const response = await this.api.get<any>(`/getAproved`);
    if (response.status !== 200) {
      return null;
    }
    // console.log(response.data);
    return response.data;
  }



  public static async getBusinessByDescription(description: string) {
    const response = await this.api.get<any>(`/business/${description}`);
    if (response.status !== 200) {

      return null;
    }
    return response.data;
  }

  public static async aproveBusiness(businessId: number, business: BusinessUpdateInterface) {
    const response = await this.api.patch<any>(`/aprove/${businessId}`, {
      closedAt: business.closedAt
    })
    if (response.status !== 201) {
      return null
    }
    return response.data
  }


  public static async cancelBusiness(businessId: number, business: BusinessUpdateInterface) {
    const response = await this.api.patch<any>(`/cancel/${businessId}`, {
      reason: business.reason
    })
    if (response.status !== 201) {
      return null
    }
    return response.data
  }

  public static async getBusinessByCompanyUser() {
    const response = await this.api.get<any>('businessC/byUserCompany');
    if (response.status !== 200) {
      return null;
    }
    return response.data;
  }

  public static async getBusiness() {
    const response = await this.api.get('/business');
    if (response.status === 200) {
      return response.data;
    }
  }

  public static async createBusiness(Busines: BusinessCreateType): Promise<Business | null> {
    const response = await this.api.post<Business>('/business', Busines);

    if (response.status !== 201) {
      return null;
    }

    return response.data;
  }
  public static async createClientBusiness(Busines: BusinessCreateType): Promise<Business | null> {
    const response = await this.api.post<Business>('/clientBusiness', Busines);

    if (response.status !== 201) {
      return null;
    }

    return response.data;
  }

  public static async updateBusiness(
    businessId: number,
    business: BusinessUpdateInterface
  ): Promise<{ success: boolean; data?: Business }> {

    try {
      const response = await this.api.post<Business>(`/business/${businessId}`, {
        description: business.description,
        contactNumber: business.contactNumber,
        observation: business.observation,
        prevision: business.prevision,
        closedAt: business.closedAt,
        status: business.status,
        reason: business.reason,
        email: business.email,
        startedAt: business.startedAt,
        updatedAt: business.updatedAt,
        clientId: business.clientId,
        activityTypesId: business.activityTypesId,
        businessSourceId: business.businessSourceId,
        administratorId: business.administratorId,
      });

      if (response.status === 201) {
        return { success: true, data: response.data };
      } else {
        return { success: false };
      }
    } catch (error) {
      console.error("Erro ao atualizar negócio:", error);
      return { success: false };
    }
  }

  // done: adicionar método para salvar comentário de um negócio
  // done: retorna comentário adicionado
  public static async createBusinessComment(BusinesComment: ICreateBusinessComment):
    Promise<_BusinessComment | null> {
    const response = await this.api.post<_BusinessComment>('/comment', BusinesComment);

    if (response.status !== 201) {
      return null;
    }

    return response.data;
  }

  // done: remover comentário
  public static async deleteBusinessComment(id: number) {
    const response = await this.api.delete<any>(`/comment/${id}`);
    if (response.status === 200) {
      return response.data;
    }
    return null;
  }
  // done: atualizar comentário
  public static async updateBusinessComment(id: number, comment: BusinessCommentUpdate) {
    const response = await this.api.patch<any>(`/comment/${id}`, { comment: comment.comment });
    if (response.status === 201) {
      return response.data;
    }
    return null;
  }

  public static async deleteBusiness(id: number) {
    const response = await this.api.delete<any>(`/business/${id}`);
    if (response.status === 200) {
      return response.data;
    }
    return null;
  }

}
